import React,{ PureComponent} from 'react';
import immutable from 'immutable';
import Contain from 'common/components/contain/Contain';
import DataTips from 'common/components/data-tips/DataTips';
import AnchorList from './anchorList/AnchorList';
import PullOnLoading from 'common/components/pull-on-loading/PullOnLoading';
import conf from 'common/js/conf';
import utils from 'common/js/utils';
import report from 'common/js/report';
import loginUtils from 'common/js/login';
import pubsub from 'common/js/pubsub';
import wxApi from 'common/js/wxapi';

const MAX_PAGE_NUM = 30;

export default class SubscriberList extends PureComponent {
    static data = [];
    static isMore = true;
    static inited = false;
    static page = 1;

    constructor(props){
        super(props);
        this.searchString = props.location.search;
        this.loading = false;
        this.url = conf.dataUrls.subscribeList;
        this.state = {
	        isLogin: loginUtils.isLogin(),
            data: SubscriberList.data,
            isMore: SubscriberList.isMore,
            inited: SubscriberList.inited
        };

        this.getData = this.getData.bind(this);
        this.handleLog = this.handleLog.bind(this);

        utils.setDocTitle();
        wxApi.init();
        wxApi.setWXShareInfo();
    }

    componentWillMount() {
        this.props.showComComponent && this.props.showComComponent();
        pubsub.subscribe('subscribeChange', function(type, msg) {
            if(msg === 'success') {
                SubscriberList.shouldRefresh = true;
            }
        });
    }

    componentDidMount() {
        this._mounted = true;

        if(this.state.isLogin && ( SubscriberList.shouldRefresh || SubscriberList.data.length === 0  )){
            this.dataInit();
        }
	    report.reportPageView({
            eid: "Pageview/sub",
            eid_desc: "Pageview/订阅列表"
        } );
    }

	dataInit() {
		SubscriberList.page = 1;
		SubscriberList.data = [];
		SubscriberList.isMore = true;
		SubscriberList.inited = false;
		SubscriberList.shouldRefresh = false;
		this.refreshData();
		this.getData();
	}

    refreshData(){
        clearTimeout(SubscriberList.refreshTimer);
        SubscriberList.refreshTimer = setTimeout(()=>{
            SubscriberList.shouldRefresh = true;
        }, 5 * 1000 *60);
    }

    componentWillUnmount(){
        this._mounted = false;
        pubsub.remove('subscribeChange');
	    report.stopPageView();
	    loginUtils.clearCallback("login");
    }

	shouldComponentUpdate(nextProps, nextState){
		if(nextState.isLogin != this.state.isLogin || nextState.isMore != this.state.isMore || nextState.inited != this.state.inited || !immutable.is(immutable.List(nextState.data),  immutable.List(this.state.data)) ){
			return true;
		}else{
			return false;
		}
	}

    render() {
        const state = this.state;
        const params = {
            search: this.searchString,
            fLoad: this.getData,
            bIsMore: state.isMore,
            bInited: state.inited,
            aData: immutable.fromJS(state.data)
        };
        var comp = null;


        if( state.isLogin ){
             comp = (
                <PullOnLoading {...params} >
	                {params.aData.size === 0 ? "" : <AnchorList />}
                </PullOnLoading>
            );
            if(state.inited === true && state.data.length === 0){
                comp = <Contain><DataTips type="noData"/></Contain>;
            }
        }else{
             comp = <Contain><DataTips type="noLogin" handleLog={this.handleLog}/></Contain>;
        }

        return (
            <div className="g-con">
                {comp}
            </div>
        );
    }

    getData( ) {

        if (this.loading) {
            return;
        }

        this.loading = true;

        utils.jsonp({
            url: this.url,
            data: {
                appId: utils.appId,
                data:JSON.stringify({
                    page: SubscriberList.page,
                    pageSize: MAX_PAGE_NUM,
                    uid:loginUtils.user.uid
                })
            }
        }).done( (res) => {
            if (res.statusCode === 200) {
                var data = res.data.list;

                if (data.length > 0) {
                    SubscriberList.page++;
                    let isMore = true;

                    if (data.length < MAX_PAGE_NUM) {
                        isMore = false;
                    }

                    if( this._mounted ){

                        this.setState({
                            data:  SubscriberList.data = utils.unique(SubscriberList.data.concat(data), 'uid'),
                            isMore: SubscriberList.isMore = isMore,
                            inited:  SubscriberList.inited = true
                        });
                    }

                } else {

                    if( this._mounted ) {
                        if (SubscriberList.page === 1) {
                            this.setState({
                                data:  SubscriberList.data = [],
                                isMore: SubscriberList.isMore = false,
                                inited:  SubscriberList.inited = true
                            });

                            //TODO 这里缺少状态
                        } else {
                            this.setState({
                                isMore: false,
                                inited:  SubscriberList.inited = true
                            });
                        }
                    }

                }
            }
        }).always( ()=>{
            this.loading = false;
        });
    }
    //登录
    handleLog(){
	    var self = this;
        loginUtils.toLogin();
	    if(!utils.isWx) {
		    loginUtils.addCallback('login', function() {
			    if(self._mounted) {
				    self.dataInit();
				    self.setState({
					    isLogin: true
				    });
			    }
		    });
	    }
    }
}


// WEBPACK FOOTER //
// ./src/views/subscriber-list/SubscriberList.jsx